<script setup>

</script>
<template>
<i class="aside-menu favorites-type">
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M7.15361 7.27995L9.31861 2.91995C9.38163 2.79377 9.47856 2.68764 9.59852 2.61347C9.71848 2.53929 9.85674 2.5 9.99778 2.5C10.1388 2.5 10.2771 2.53929 10.397 2.61347C10.517 2.68764 10.6139 2.79377 10.6769 2.91995L12.8419 7.27995L17.6819 7.98328C17.8215 8.00264 17.9529 8.06086 18.061 8.15129C18.1691 8.24173 18.2496 8.36073 18.2933 8.49472C18.337 8.62872 18.3422 8.7723 18.3082 8.90908C18.2742 9.04586 18.2024 9.17033 18.1011 9.26829L14.5994 12.66L15.4261 17.4516C15.5319 18.0666 14.8819 18.535 14.3261 18.245L9.99778 15.9816L5.66861 18.245C5.11361 18.5358 4.46361 18.0666 4.56944 17.4508L5.39611 12.6591L1.89444 9.26745C1.7936 9.16943 1.72228 9.04508 1.68858 8.90855C1.65489 8.77201 1.66017 8.62876 1.70383 8.49507C1.7475 8.36139 1.82779 8.24264 1.93558 8.15231C2.04338 8.06199 2.17435 8.00372 2.31361 7.98412L7.15361 7.27995Z" fill="url(#paint0_linear_284_180)" stroke="url(#paint1_linear_284_180)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <defs>
      <linearGradient id="paint0_linear_284_180" x1="9.99853" y1="2.5" x2="9.99853" y2="18.3333" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FFD910"/>
        <stop offset="1" stop-color="#FFE34E"/>
      </linearGradient>
      <linearGradient id="paint1_linear_284_180" x1="9.99853" y1="2.5" x2="9.99853" y2="18.3333" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FFD910"/>
        <stop offset="1" stop-color="#FFE34E"/>
      </linearGradient>
    </defs>
  </svg>
</i>
</template>
<style scoped>

</style>